/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuDots9Icon16Light } from './UiMenuDots9Icon16Light';
import { UiMenuDots9Icon16Regular } from './UiMenuDots9Icon16Regular';
import { UiMenuDots9Icon16Solid } from './UiMenuDots9Icon16Solid';
import { UiMenuDots9Icon20Light } from './UiMenuDots9Icon20Light';
import { UiMenuDots9Icon20Regular } from './UiMenuDots9Icon20Regular';
import { UiMenuDots9Icon20Solid } from './UiMenuDots9Icon20Solid';
import { UiMenuDots9Icon24Regular } from './UiMenuDots9Icon24Regular';
import { UiMenuDots9Icon24Solid } from './UiMenuDots9Icon24Solid';
import { UiMenuDots9Icon32Regular } from './UiMenuDots9Icon32Regular';
import { UiMenuDots9Icon64Regular } from './UiMenuDots9Icon64Regular';
var sizes = {
    16: {
        light: UiMenuDots9Icon16Light,
        regular: UiMenuDots9Icon16Regular,
        solid: UiMenuDots9Icon16Solid,
    },
    20: {
        light: UiMenuDots9Icon20Light,
        regular: UiMenuDots9Icon20Regular,
        solid: UiMenuDots9Icon20Solid,
    },
    24: {
        regular: UiMenuDots9Icon24Regular,
        solid: UiMenuDots9Icon24Solid,
    },
    32: {
        regular: UiMenuDots9Icon32Regular,
    },
    64: {
        regular: UiMenuDots9Icon64Regular,
    },
};
export var UiMenuDots9Icon = forwardRef('UiMenuDots9Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
